export const Modal = {
  baseStyle: {
    overlay: {
      zIndex: 1700,
    },
    dialogContainer: {
      zIndex: 1700,
    },
    header: {
      textTransform: 'lowercase',
      'h1::first-letter': { textTransform: 'uppercase' },
      'h2::first-letter': { textTransform: 'uppercase' },
      'p::first-letter': { textTransform: 'uppercase' },
    },
  },
};
